/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMicWarning = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12 2a4 4 0 0 0-4 4v4a4 4 0 0 0 8 0V6a4 4 0 0 0-4-4zm-2 4a2 2 0 1 1 4 0v4a2 2 0 1 1-4 0z" />
        <path d="M12 16a6 6 0 0 1-6-6H4a8.001 8.001 0 0 0 7 7.938V20H7v2h10v-2h-4v-2.062a7.998 7.998 0 0 0 5.566-3.366l-1.64-1.144A5.992 5.992 0 0 1 12 16zm9-7V2h-2v7zm0 3v-2h-2v2z" />
      </g>
    </g>
  </Icon>
);
export { SvgMicWarning as MicWarning };
